/* eslint-disable @typescript-eslint/naming-convention */
import { AWCListItem } from '@ansys-internal/awc-angular/lists';
import {
  ComponentFileType,
  InverterIGBTData,
  InverterLossMapID,
  InverterMOSFETData,
} from 'src/api';

export const inverterSelectTypes: AWCListItem[] = [
  {
    text: 'IGBT',
    id: 'InverterIGBTData',
    userData: {} as InverterIGBTData,
  },
  {
    text: 'MOSFET',
    id: 'InverterMOSFETData',
    userData: {} as InverterMOSFETData,
  },
  {
    text: 'Loss Map',
    id: 'InverterLossMapID',
    userData: {
      type: ComponentFileType.INVERTER_LOSS_FILE,
      upload: true,
      component_type: 'InverterLossMapID',
      file_types: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
      ],
      defaultPart: {},
    } as InverterLossMapID,
  },
];
